import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Message from "semantic-ui-react/dist/es/collections/Message/Message.js";
export var Component = function Component(_ref) {
  var children = _ref.children,
      isTextAlignedCenter = _ref.isTextAlignedCenter;
  return React.createElement(Message, {
    className: classNames('padded', {
      'text-aligned-center': isTextAlignedCenter
    })
  }, children);
};
Component.displayName = 'Message';
Component.defaultProps = {
  children: null,
  isTextAlignedCenter: false
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  isTextAlignedCenter: PropTypes.bool
} : {};